import * as React from 'react';
import { NAVOrder, NavOrderResult } from '../models/interfaces';

interface ModalProps {
  title: React.ReactNode;
  close: (value: boolean) => void;
  show: boolean;
  onlyCloseButton?: boolean;
  isLoading?: boolean;
  errorClass?: boolean;
  size?: string;
  orders?: Array<NavOrderResult>;
  errorText?: Array<string>;
}

class Modal extends React.Component<ModalProps> {

  render() {
    const {
      close,
      title,
      show,
      children,
      onlyCloseButton,
      isLoading,
      errorClass,
      size,
      orders,
      errorText
    } = this.props;

    const buttons = () => {
      if (isLoading) {
        return null;
      }

      if (onlyCloseButton) {
        return (
          <div
            className="action button"
            onClick={() => close(false)}
          >Sulje
          </div>
        );
      }

      return (
        <div className="actions">
          <div
            className="action button button--notice"
            onClick={() => close(false)}
          >Peru
          </div>
          <div
            className="action button"
            onClick={() => close(true)}
          >Hyväksy
          </div>
        </div>
      );
    };

    const clasSNames = () => {
      let classes = 'modal';

      if (errorClass) {
        classes += ' modal--error';
      }

      if (size) {
        classes += ` modal--${size}`;
      }

      return classes;
    };

    const errorMessage = () => {
      if (errorText && errorText.length) {
        return <h2 className="error-text">{errorText}</h2>;
      }
      return null;
    };

    const backgroundClick = (e: any) => { // tslint:disable-line
      e.preventDefault();
      e.stopPropagation();

      if (e.target.className && e.target.className === 'background-modal') {
        close(false);
      }
    };

    if (!show) {
      return null;
    }

    return (
      <div className="background-modal" onClick={e => backgroundClick(e)}>
        <div className={clasSNames()}>
          <div className="modal__body">
            {title}
            {children}
            {errorMessage()}
          </div>
          <div className="modal__actions">
            {buttons()}
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Modal.tsx